/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Ready_DescInputs */



/**
* | output |
* | --- |
* | "The form below is filled in. Change anything you like, then create." |
*
* @param {Tournament_Wiz_Ready_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_ready_desc = /** @type {((inputs?: Tournament_Wiz_Ready_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Ready_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le formulaire ci-dessous est prérempli. Modifiez ce que vous voulez, puis créez.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El formulario de abajo está rellenado. Cambie lo que quiera y cree el torneo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O formulário abaixo está preenchido. Mude o que quiser e crie.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il modulo qui sotto è compilato. Cambia quello che vuoi, poi crea.")
	return /** @type {LocalizedString} */ ("The form below is filled in. Change anything you like, then create.")
});